import styled from 'styled-components'
import { Button as UIKitButton } from '@urbaninfrastructure/react-ui-kit'

const Button = styled(UIKitButton)``

Button.defaultProps = {
  shape: 'cool',
}

export default Button
